export const colors=[
  '#FF99C3',
  '#73A0FA',
  '#73DEB3',
  '#7585A2',
  '#F7C739',
  '#EB7E65',
  '#9661BC',
  '#6DC8EC',
  '#BDD2FD',
  '#FF99C3',
  '#269A99',
  '#5D7092',
  '#FF99C3',
  '#73A0FA',
  '#73DEB3',
  '#7585A2',
  '#F7C739',
  '#EB7E65',
  '#9661BC',
  '#6DC8EC',
  '#BDD2FD',
  '#FF99C3',
  '#269A99',
  '#5D7092',
]
